import CloseSurveyButton from "../atoms/buttons/CloseSurveyButton.jsx";
import SurveyForm from "../atoms/forms/SurveyForm.jsx";

export default function SurveyFormContainer() {

    return (
        <div className="survey-container">
            <div className="survey-div">
                <CloseSurveyButton/>
                <SurveyForm/>
            </div>
        </div>
    );
};
